module.exports = __webpack_public_path__ + "img/nmang4.c8bb2677.jpg";